module.exports = __webpack_public_path__ + "static/img/horn.0627649.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/neutral/horn.png
// module id = HOvq
// module chunks = 0